// lib
import React, { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Transition } from 'react-transition-group'

// styles
import style from '@aytm/app/stats/page/question-views/components/styles/Component.module.scss'

export const DataContext = React.createContext()

const Component = ({ Controls, children, model, data, states, changed, disabled, ...props }) => {
  const [collapsed, setCollapsed] = useState(
    !states.error && states.loaded && (states.collapsed == undefined || states.collapsed)
  )
  const [maxHeight, setMaxHeight] = useState(0)

  const [transitionDuration, setTransitionDuration] = useState(500)

  const componentRef = useRef()

  const collapsedRef = useRef()
  collapsedRef.current = collapsed

  const onToggle = () => {
    setCollapsed(!collapsedRef.current)
    setTransitionDuration(500)
  }

  // TODO
  useEffect(() => {
    states.collapsed != undefined && setCollapsed(states.collapsed)
  }, [states.collapsed])

  useEffect(() => {
    setMaxHeight(componentRef.current ? componentRef.current.getBoundingClientRect().height : 0)
    setTransitionDuration(collapsed ? 500 : 10)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [children, states.error, collapsed, componentRef.current])

  useEffect(() => {
    collapsedRef.current && !changed && !states.loading && setCollapsed(!states.error && states.loaded)
  }, [states.error, states.loaded, states.loading, changed])

  return (
    <div className={style.component}>
      <Controls model={model} data={data} collapsed={collapsed} disabled={disabled} onToggle={onToggle} {...props} />
      <Transition in={!collapsed} timeout={transitionDuration}>
        {status => (
          <div
            className={`${style['transition-panel']}${status ? ' ' + style['transition-panel-' + status] : ''}`}
            style={{
              maxHeight: collapsed ? 0 : `${0 < maxHeight ? maxHeight + 40 : 10000}px`,
              transitionDuration: `${transitionDuration}ms`
            }}
          >
            <div ref={componentRef} className={style['component-children']}>
              {children}
              {'string' == typeof states.error && (
                <div className={`${style.row} ${style['row-error']} p-fluid p-col-12`}>{states.error}</div>
              )}
            </div>
          </div>
        )}
      </Transition>
    </div>
  )
}

Component.propTypes = {
  Controls: PropTypes.any,
  children: PropTypes.any,
  model: PropTypes.object,
  data: PropTypes.object,
  states: PropTypes.object,
  changed: PropTypes.bool,
  disabled: PropTypes.bool
}

Component.displayName = 'Component'

export default Component
